
export class FacturaSeleccionadaModel {
  factura: string;
  seleccionada: boolean;
  noEntrada: number;
}
